export default __webpack_public_path__ + "static/media/menu-h_01.47066423.jpg";